module.exports = __webpack_public_path__ + "img/bn-solutions-bg.a6c9cc6c.svg";